import React from "react";
import FlipMove from "react-flip-move";

export default ({ enterAnimation, leaveAnimation, delay, children }) => {
  return (
    <FlipMove
      appearAnimation={enterAnimation}
      enterAnimation={enterAnimation}
      leaveAnimation={leaveAnimation}
      delay={delay}>
      {children}
    </FlipMove>
  );
};



// WEBPACK FOOTER //
// ./src/canvas/enhancers/animable.js